import React from 'react'
import { CircularProgress as Progress } from '@mui/material';
const CircularProgress = () => {
    return (
        <Progress size={20} color="inherit" style={{ marginLeft: 5 }} />
    )
}

export default CircularProgress